import { Component, Input, forwardRef, Inject } from '@angular/core';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CompanyService }       from '../companies/company.service';
import { CompanySettingsModel } from '../companies/models/company.settings';
import { MobileService }        from './mobile.service';
import { MessagesService }      from '../messages/messages.service';

@Component({
  selector   : 'wor-mobile-video-settings',
  template: require('./mobile.video-settings.component.html')
})
export class MobileVideoSettingsComponent {
  @Input() settings           : CompanySettingsModel;
  @Input() videoStorageMinutes: string;

  constructor (
    @Inject(forwardRef(() => CompanyService))
    public  companyService  : CompanyService,
    @Inject(forwardRef(() => MessagesService)) private messagesService : MessagesService,
    @Inject(forwardRef(() => MobileService)) private mobileService   : MobileService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  activate () : void {
    this.mobileService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VIDEO_SETTINGS.TITLE')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  buyVideoMinutes () : void {
    this.mobileService.purchaseVideoMinutes()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PURCHASED_INTEGRATION', {
        name: this.translateService.instant('GENERAL_SPACE.FIELD.VIDEO_STORAGE_MINUTES')
      }), 'success');

      this.router.stateService.reload();
    });
  };

  deactivate () : void {
    this.mobileService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VIDEO_SETTINGS.TITLE')
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  save ( form : NgForm ) : void {
    this.mobileService.saveSettings(this.settings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }
}
